import { useEffect, useState } from "react";
import { LuPhone, LuSmartphone } from "react-icons/lu";
import QuoteStepHeading from "../../../../shared/components/QuoteStepHeading";
import ContactOptionCard from "../ContactOptionCard";
import PortalBackButton from "../PortalBackButton";
import PageContentStack from "../../../../shared/components/PageContentStack";

const ClaimSectionCards = ({ insurer }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateMobileState = () => setIsMobile(window.innerWidth < 768);
    updateMobileState();
    window.addEventListener("resize", updateMobileState);
    return () => window.removeEventListener("resize", updateMobileState);
  }, []);

  let phoneNumber;
  let callText;
  if (insurer.toLowerCase().includes("ers")) {
    phoneNumber = "03301235992";
    callText = (
      <>
        Report your claim as soon as possible by calling{" "}
        <strong>0330 123 5992</strong>
      </>
    );
  } else if (insurer.toLowerCase().includes("kgm")) {
    phoneNumber = "03335555909";
    callText = (
      <>
        Report your claim as soon as possible by calling{" "}
        <strong>0333 555 5909</strong>
      </>
    );
  } else if (insurer.toLowerCase().includes("qbe")) {
    phoneNumber = "08003891708";
    callText = (
      <>
        Report your claim as soon as possible by calling{" "}
        <strong>0800 389 1708</strong>
      </>
    );
  } else if (insurer.toLowerCase().includes("inshur")) {
    phoneNumber = "0808 164 6545";
    callText = (
      <>
        Report your claim as soon as possible by calling{" "}
        <strong>0808 164 6545</strong>. You can also use this number for updates
        on an existing claim.
      </>
    );
  } else {
    phoneNumber = "08081606752";
    callText = (
      <>
        Report your claim as soon as possible by calling{" "}
        <strong>0808 160 6752</strong>
      </>
    );
  }

  const isSpecialInsurer =
    insurer.toLowerCase().includes("ers") ||
    insurer.toLowerCase().includes("qbe") ||
    insurer.toLowerCase().includes("kgm") ||
    insurer.toLowerCase().includes("inshur");

  return (
    <PageContentStack>
      <div className="tw-mt-3">
        <QuoteStepHeading
          title="Get in touch with our team"
          className="tw-m-0"
          titleClassName="tw-m-0"
        />
      </div>

      <div className="tw-flex tw-flex-col tw-gap-4">
        <ContactOptionCard
          title="Call"
          description={callText}
          buttonLabel="Call Now"
          icon={
            <LuPhone
              className="tw-h-7 tw-w-7"
              strokeWidth={2.3}
              aria-hidden="true"
            />
          }
          onClick={() => window.open(`tel:${phoneNumber}`, "_self")}
        />
        {!isSpecialInsurer && (
          <ContactOptionCard
            title="SMS"
            description="Send a text message to +44 7455 715794 for existing claims or use our live chat support."
            buttonLabel="Send a text"
            icon={
              <LuSmartphone
                className="tw-h-7 tw-w-7"
                strokeWidth={2.3}
                aria-hidden="true"
              />
            }
            onClick={() => window.open("sms:+447455715794", "_self")}
            disabled={!isMobile}
          />
        )}
      </div>
      <PortalBackButton />
    </PageContentStack>
  );
};

export default ClaimSectionCards;
